export default __webpack_public_path__ + "../ckeditor/skins/moono-lisa/readme.md";